import React from "react";
import { Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";

const NotFoundPage = ({ errorMessage }) => {
  return (
    <Styles>
      <Typography
        variant="h2"
        color="primary"
        component="h1"
        align="center"
        gutterBottom
      >
        خطا!
      </Typography>
      <Typography variant="h5" color="primary" align="center" gutterBottom>
        مشکلی در سایت رخ داده است.
      </Typography>
      <Typography variant="body1" align="center" gutterBottom>
        {errorMessage}
      </Typography>
      <Button variant="contained" color="primary" size="large" fullWidth>
        <Link to="/">بازگشت به صفحه اصلی</Link>
      </Button>
    </Styles>
  );
};

export default NotFoundPage;

const Styles = styled.div`
  max-width: 70%;
  min-width: 70%;
  max-height: 50vh;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;
